/* Keep mobile chrome in step with Dawn's native cart; never intercept checkout. */
(() => {
  function initializeShell() {
    const footerNav = document.querySelector('.bp-shell-bottom-nav');
    if (!footerNav || footerNav.dataset.initialized) return;
    footerNav.dataset.initialized = 'true';
    const count = footerNav.querySelector('[data-bp-cart-count]');
    const headerIcons = document.querySelector('.bp-shell-header .header__icons');
    function synchronizeCartCount() {
      if (!count || !headerIcons) return;
      const nativeCount = headerIcons.querySelector('#cart-icon-bubble .cart-count-bubble');
      const value = nativeCount?.textContent.match(/\d+/)?.[0] || '0';
      count.textContent = value || '0';
      count.setAttribute('aria-label', `${value || '0'} items in cart`);
    }
    synchronizeCartCount();
    if (headerIcons) {
      const observer = new MutationObserver(synchronizeCartCount);
      observer.observe(headerIcons, { childList: true, subtree: true, characterData: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(footerNav) || event.target.contains(headerIcons)) observer.disconnect();
      }, { once: true });
    }
    footerNav.querySelector('[data-bp-back]')?.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      try {
        if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
          event.preventDefault();
          history.back();
        }
      } catch (_) { /* The normal collection link remains the safe fallback. */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeShell, { once: true });
  else initializeShell();
  document.addEventListener('shopify:section:load', initializeShell);
})();
